<div class="form-dialog conditional-formatting-form">
  <div class="row" style="justify-content: space-between;">
    <div>@if (!has_key) {
      <span>Please select a component type or event type</span>
    }</div>
    <button mat-flat-button matTooltip="Add new conditional format" matTooltipPosition="above"
      style="margin:0;" (click)="addFormatRule()" [disabled]="!has_key" data-testid="cf-add-format">
      <i class="fa fa-plus" style="margin-right:10px;"></i>Add conditional format
    </button>
  </div>

  @if (available_columns?.length > 0) {
    @for (condition of config.conditional_formats; track condition; let c = $index) {
      <div class="row formatting-rule">
        <select-many-filter
          [options]="available_columns"
          [stringFunction]="stringFunction"
          [modelValue]="condition.columns"
          [listType]="'columns'"
          [label]="'Apply to'"
          [filter_compare]="columnCompare"
          (constant_changed)="condition.columns=$event;"
          [classes]="'fill'"
          class="select-search"
        ></select-many-filter>
        <div class="column">
          <mat-form-field class="full-width">
            <mat-label>Format cells if...</mat-label>
            <mat-select [(ngModel)]="condition.comparer">
              @for (comparer of operator_dict | keyvalue : originalOrder; track comparer.key) {
                <mat-option
                  [value]="comparer.key">{{comparer.value}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <ng-container>
            @if (!['<>', '><', 'auto', 'empty', 'not_empty'].includes(condition.comparer)) {
              <input matInput step="any" [(ngModel)]="condition.value" placeholder="value" class="formatting-value"/>
            }
            @if (['<>', '><'].includes(condition.comparer)) {
              <input matInput type="number" step="any" [(ngModel)]="condition.lower" placeholder="lower limit"
                class="formatting-value"/>
              <input matInput type="number" step="any" [(ngModel)]="condition.upper" placeholder="upper limit"
                class="formatting-value"
                style="margin-top:10px;"/>
            }
          </ng-container>
        </div>
        <div class="column conditional-formatting-styles">
          <label>Formatting style</label>
          @if (condition.comparer === 'auto') {
            <div> Auto formatting will be applied.</div>
          }
          @if (condition.comparer !== 'auto') {
            <div class="conditional-formats-column-menu">
              <div>
                <h3 [ngClass]="{'active': !condition.named_format}" (click)="condition.named_format = null">Custom</h3>
                <h3 [ngClass]="{'active': condition.named_format}"
                (click)="condition.named_format ='ok';openNamedSelect(c)">Standard</h3>
              </div>
              @if (!condition.named_format) {
                <table-column-menu
                  [item]="conditional_formats_dict[c]"
                  [options]="col_menu_options"
                  (formatsChanged)="condition.format = $event">
                </table-column-menu>
              }
              @if (condition.named_format) {
                <mat-form-field>
                  <mat-select [value]="condition.named_format" style="width:100%;" #select_named_format
                    [ngStyle]="named_format_styles[condition.named_format]" panelClass="named-format-select"
                    (selectionChange)="namedFormat(condition, $event)" [compareWith]="namedFormatCompare">
                    @for (format of named_formats | keyvalue : compareByTitle; track format.key) {
                      <mat-option
                        [value]="format" [ngStyle]="named_format_styles[format.key]">{{format.value.title}}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
            </div>
          }
        </div>
        <div class="remove-format-container">
          <button mat-button (click)="removeFormat(c)" class="remove-format" data-testid="cf-remove-format">
            <i class="fa fa-trash" style="margin-right:10px;"></i>
            Remove rule
          </button>
        </div>
      </div>
    }
  }
</div>
